import Flickity from 'flickity-imagesloaded'

export const settings = {
  selector: '.js-contact-persons-carousel',
  cellSelector: '.js-contact-persons-carousel-slide'
}

/**
 * Function initializes all elements in page.
 */
export default function initAll() {
  let elements = document.querySelectorAll( settings.selector )
  Array.from( elements ).forEach(( element ) => {
    init( element )
  })
}

/**
 * Function checks if arrows are disabled and hides them.
 * @param {DOMNode} element
 */
function hideArrowsIfDisabled() {
  const elements = document.querySelectorAll( '.flickity-prev-next-button.previous' )
  Array.from( elements ).forEach(( prevButton ) => {
    const nextButton = prevButton.nextSibling
    if ( prevButton.disabled && nextButton.disabled ) {
      prevButton.style.visibility = 'hidden'
      nextButton.style.visibility = 'hidden'
    } else {
      prevButton.style.visibility = 'visible'
      nextButton.style.visibility = 'visible'
    }
  })
}

/**
 * Function initializes single element.
 * @param {DOMNode} element
 */
export function init( element ) {
  const cellElements = Array.from( element.querySelectorAll( settings.cellSelector ))
  if ( cellElements.length > 1 ) {
    initCarousel( element )
  }
  setTimeout( hideArrowsIfDisabled, 1000 )
}

/**
 *
 * @param {DOMNode} carouselEl
 */
function initCarousel( carouselEl ) {
  // eslint-disable-next-line no-unused-vars
  const carousel = new Flickity( carouselEl, {
    imagesLoaded: true,
    cellSelector: settings.cellSelector,
    pageDots: false,
    prevNextButtons: true,
    draggable: false,
    autoPlay: false,
    pauseAutoPlayOnHover: false,
    wrapAround: false,
    arrowShape: {
      x0: 20,
      x1: 70, y1: 40,
      x2: 70, y2: 0,
      x3: 70
    }
  })
}
